import { jsx as _jsx } from "react/jsx-runtime";
import { ResponsiveChord } from '@nivo/chord';
import { getLatestAppVersion } from '@ui/utils';
import { NoDependenciesWarning } from './emptyState';
import { checkIfMatrixHasAtLeastOneDependency } from './utils';
export const ModuleChordChart = (param)=>{
    let { applications } = param;
    const modules = applications.flatMap((param)=>{
        let { versions } = param;
        var _ref;
        const latestVersion = getLatestAppVersion(versions !== null && versions !== void 0 ? versions : []);
        return (_ref = latestVersion === null || latestVersion === void 0 ? void 0 : latestVersion.modules) !== null && _ref !== void 0 ? _ref : [];
    });
    const columns = applications.length + modules.length;
    const matrix = new Array(columns).fill(0).map(()=>new Array(columns).fill(0));
    const keys = [];
    const appById = {};
    const modulesById = {};
    applications.forEach((param)=>{
        let { id, name: appName, versions } = param;
        var _ref;
        appById[id] = keys.length;
        keys.push(appName);
        const latestVersion = getLatestAppVersion(versions !== null && versions !== void 0 ? versions : []);
        ((_ref = latestVersion === null || latestVersion === void 0 ? void 0 : latestVersion.modules) !== null && _ref !== void 0 ? _ref : []).forEach((param)=>{
            let { name: moduleName } = param;
            modulesById["".concat(appName, "/").concat(moduleName)] = keys.length;
            keys.push("".concat(appName, "/").concat(moduleName));
        });
    });
    applications.forEach((param)=>{
        let { id, versions } = param;
        var _ref;
        const latestVersion = getLatestAppVersion(versions !== null && versions !== void 0 ? versions : []);
        ((_ref = latestVersion === null || latestVersion === void 0 ? void 0 : latestVersion.consumes) !== null && _ref !== void 0 ? _ref : []).forEach((param)=>{
            let { applicationID: appName, name, usedIn } = param;
            var _ref, _ref1;
            const modId = "".concat(appName, "/").concat(name);
            const module = modulesById[modId];
            if (module === undefined) {
                return;
            }
            const appIndex = appById[id];
            if (appIndex === undefined) {
                return;
            }
            const appRow = matrix[appIndex];
            const moduleRow = matrix[module];
            if (!appRow || !moduleRow) {
                return;
            }
            appRow[module] = (_ref = usedIn === null || usedIn === void 0 ? void 0 : usedIn.length) !== null && _ref !== void 0 ? _ref : 0;
            moduleRow[appIndex] = (_ref1 = usedIn === null || usedIn === void 0 ? void 0 : usedIn.length) !== null && _ref1 !== void 0 ? _ref1 : 0;
        });
    });
    const hasAtLeastOneDependency = checkIfMatrixHasAtLeastOneDependency(matrix);
    if (!hasAtLeastOneDependency) {
        return /*#__PURE__*/ _jsx(NoDependenciesWarning, {});
    }
    return /*#__PURE__*/ _jsx("div", {
        style: {
            height: 'calc(100vh - 250px)',
            width: '100%'
        },
        children: /*#__PURE__*/ _jsx(ResponsiveChord, {
            data: matrix,
            keys: keys,
            margin: {
                top: 60,
                right: 60,
                bottom: 90,
                left: 60
            },
            valueFormat: ".2f",
            padAngle: 0.02,
            innerRadiusRatio: 0.96,
            innerRadiusOffset: 0.02,
            arcOpacity: 1,
            arcBorderWidth: 1,
            arcBorderColor: {
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        0.4
                    ]
                ]
            },
            ribbonOpacity: 0.5,
            ribbonBorderWidth: 1,
            ribbonBorderColor: {
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        0.4
                    ]
                ]
            },
            enableLabel: true,
            label: "id",
            labelOffset: 12,
            labelRotation: -90,
            labelTextColor: {
                from: 'color',
                modifiers: [
                    [
                        'opacity',
                        1
                    ],
                    [
                        'darker',
                        1
                    ]
                ]
            },
            colors: {
                scheme: 'nivo'
            },
            isInteractive: true,
            animate: true,
            legends: [
                {
                    anchor: 'top-left',
                    direction: 'column',
                    justify: false,
                    itemWidth: 80,
                    itemHeight: 14,
                    itemsSpacing: 2,
                    itemTextColor: 'hsl(var(--muted-foreground))',
                    itemDirection: 'left-to-right',
                    symbolSize: 12,
                    symbolShape: 'circle',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemTextColor: 'hsl(var(--foreground))'
                            }
                        }
                    ]
                }
            ],
            theme: {
                tooltip: {
                    container: {
                        color: 'hsl(var(--foreground))',
                        fontSize: 14
                    }
                }
            }
        })
    });
};
